<div class="attachments-component-container">
  <div class="form-field-wrapper">
    <label class="form-field-label" [ngClass]="{ 'required': isRequired && !readonly, 'text-dark': readonly }">
      <app-input-helper-text [helpText]="helpText"></app-input-helper-text>
      {{ label }}
    </label>
    <div class="center">
      @if(!(!allowMultiple && uploadedFiles.length) && !disabled) {
        <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)" [multiple]="allowMultiple"
          (onFileLeave)="fileLeave($event)">
          <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector" (click)="openFileSelector()">
            <div class="drop-container" (click)="openFileSelector()">
              <label class="header">{{ 'label.attachments_container.title' | translate }}</label>
              <label class="sub-header">{{ 'label.attachments_container.sub_title' | translate: { size: fileSizeLimitInMB } }}</label>
            </div>
          </ng-template>
        </ngx-file-drop>
      }
    <div class="file-wrapper row">
        <div *ngFor="let file of uploadedFiles" class="file-card d-flex" [ngClass]="{'col-lg-6 col-md-12': allowMultiple, 'col-12': !allowMultiple}">
          <div class="file-card-content" [ngClass]="{'clickable': readonly}">
            <i [title]="'label.click_to_download' | translate" class="bi bi-file-earmark-arrow-down file-icon" (click)="readonly ? downloadFile(file) : null"></i>
            <label>
              <div class="file-name">{{ file.name }}</div>
              <div class="file-size">{{ file.size }}</div>
            </label>
            @if(!disabled) {
              <i class="bi bi-x x-icon" (click)="removeFile(file)"></i>
            }
          </div>
        </div>
      @if(!uploadedFiles.length) {
        <div class="no-items-global">{{ 'label.no-attachments' | translate }}</div>
      }
    </div>
    @if(readonly && uploadedFiles.length && !touched) {
      <div class="download-all">
        <button class="download-all-button" (click)="downloadAllAttachments()"><i class="bi bi-file-zip-fill"></i> {{ 'buttons.download_all' | translate }}</button>
      </div>
    }
    </div>
  </div>
</div>

